/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * PostHog API - 1 ops
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod'

export const WidgetAssigneeFilter = /* @__PURE__ */ zod.object({
    id: zod.union([zod.string(), zod.number()]),
    type: zod.enum(['user', 'role']),
})

export type WidgetAssigneeFilter = zod.input<typeof WidgetAssigneeFilter>
export type WidgetAssigneeFilterOutput = zod.output<typeof WidgetAssigneeFilter>
